import * as React from "react";

function GSKIcon(props) {
  const { className, height, width } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 53 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Path_7032"
        data-name="Path 7032"
        d="m 10.6,20.830414 v -2.08 c -2.1,-0.2 -2.68,-2.42 -2.68,-4.74 0,-2.28 0.58,-4.46 2.68,-4.74 v -2.12 h -0.28 c -4.16,0 -6.3,3.22 -6.3,6.86 0,3.78 2.36,6.84 6.12,6.84 0.16,0 0.3,-0.02 0.46,-0.02 z m 0.78,-13.6 v 2.02 a 3.228,3.228 0 0 1 2.98,2.66 h 2 v -4.54 h -2.08 c 0,1.86 -0.4,0.26 -2.9,-0.14 z m 0,11.52 v 2 c 2.58,-0.42 3.48,-1.94 3.48,-0.12 h 1.94 v -3.84 c 0,-1.44 -0.22,-1.44 1.5,-1.44 v -2.06 h -7.58 v 2.06 c 2.28,0 2.46,0 2.46,1.12 v 1.34 a 2.923,2.923 0 0 1 -1.8,0.94 z m 16.6,-1.38 c 0,-2.88 -8.48,-0.7 -8.48,-6.48 0,-2.44 2.08,-3.74 4.94,-3.74 a 3.54,3.54 0 0 1 0.46,0.02 v 1.98 c -1.4,0.1 -1.82,0.66 -1.82,1.18 0,2.42 8.52,0.84 8.52,6.56 0,2.62 -1.98,3.96 -5.18,3.96 -0.26,0 -0.5,-0.02 -0.74,-0.04 v -1.92 c 1.64,-0.06 2.3,-0.7 2.3,-1.52 z m 0.92,-10 h 2.14 v 4.38 H 28.9 a 3.254,3.254 0 0 0 -3.22,-2.6 v -1.92 c 2.64,0.3 3.22,1.46 3.22,0.14 z m -7.22,13.26 H 19.5 v -5.06 h 2.18 a 3.413,3.413 0 0 0 3.22,3.3 v 1.84 c -2.26,-0.38 -3.22,-1.4 -3.22,-0.08 z m 17.18,-9.76 v 6.26 c 0,1.44 -0.12,1.44 1.66,1.44 v 2.06 H 33 v -2.06 c 2.18,0 2.18,0 2.18,-1.44 v -6.26 c 0,-1.44 0,-1.44 -2.18,-1.44 v -2.06 h 7.52 v 2.06 c -1.78,0 -1.66,0 -1.66,1.44 z m 0.78,4.36 v -2.72 l 2.34,-2.12 c 0.82,-0.74 0.52,-0.96 -0.72,-0.96 v -2.06 h 6.9 v 2.06 c -2.12,0 -2.42,0.28 -3.52,1.26 z m 6.4,1.58 a 3.411,3.411 0 0 0 2.94,1.76 v 2.06 h -7.72 v -2.06 c 1.4,0 1.44,-0.12 0.9,-1.02 l -1.46,-2.22 2.6,-2.36 c 0,0 1.94,2.76 2.74,3.84 z"
        fill="#ff9d00"
        clipPath="none"
      />
    </svg>
  );
}

export default GSKIcon;
